import { motion } from 'motion/react';
import type { WorkOption } from '../types';

interface FreelanceShapesProps {
  step?: 1 | 2 | 3;
  selectedWorkOption: WorkOption | null;
}

export function FreelanceShapes({
  step = 1,
  selectedWorkOption,
}: FreelanceShapesProps): JSX.Element {
  const getContainerStyle = () => {
    if (step === 3) {
      return { transform: 'translate(-40px, 240px) scale(1)', opacity: 1 };
    }
    if (step === 2 && selectedWorkOption !== null) {
      return { transform: 'translate(-250px, -150px) scale(0.9)', opacity: 0.4 };
    }
    return undefined;
  };

  return (
    <div
      className="absolute left-[320px] top-[230px] transition-all duration-1000"
      style={getContainerStyle()}
    >
      <motion.div
        className="absolute size-[328px]"
        initial={{ opacity: 0, rotate: 90, scale: 0.8 }}
        animate={{ opacity: 1, rotate: 0, scale: 1 }}
        exit={{ opacity: 0, rotate: -90, scale: 0.8 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 328 328"
        >
          <g id="Group">
            <path
              clipRule="evenodd"
              d="M43.0698 164C-60.5878 288.043 39.9576 388.588 164 284.93C288.018 388.588 388.588 287.948 284.93 164C388.588 39.9576 288.018 -60.5878 164 43.0698C39.9576 -60.5878 -60.5878 39.9576 43.0698 164ZM164 224.68C197.513 224.68 224.68 197.513 224.68 164C224.68 130.487 197.513 103.32 164 103.32C130.487 103.32 103.32 130.487 103.32 164C103.32 197.513 130.487 224.68 164 224.68Z"
              fill="#8BFFAC"
              fillRule="evenodd"
              id="Vector"
            />
          </g>
        </svg>
      </motion.div>
      <motion.div
        className="absolute size-[263px] left-[90px] top-[100px]"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 263 263"
        >
          <g id="Group">
            <path
              d="M0 0H131.184C203.634 0 262.368 58.7331 262.368 131.184V262.368H131.184C58.7331 262.368 0 203.634 0 131.184V0Z"
              fill="#8FA1FF"
              id="Vector"
            />
          </g>
        </svg>
      </motion.div>
    </div>
  );
}
